'use strict'
exports.__esModule = true
exports.default = void 0

var _num = require('../num')
var _bool = require('../bool')
var _str = require('../str')
var ValidationUtils = /*#__PURE__*/ (function() {
  function ValidationUtils() {}
  ValidationUtils.createVal = function createVal(val, opts) {
    if (opts === void 0) {
      opts = {}
    }
    return {
      val: val,
      isValid: false,
      isChanging: false,
      isEmpty: true,
      maxLength: (0, _num.castNum)(opts.maxLength, -1),
      required: (0, _bool.castBool)(opts.required),
      allowEmpty: true,
      get valStr() {
        return this.val === -1 ? '' : '' + this.val
      },
      get shouldDisplayErr() {
        var isChanging = this.isChanging,
          isValid = this.isValid,
          isEmpty = this.isEmpty,
          required = this.required,
          allowEmpty = this.allowEmpty

        if (required) {
          return !isChanging && ((isEmpty && !allowEmpty) || (!isValid && !isEmpty))
        }

        return !isChanging && !isEmpty && !isValid
      }
    }
  }
  ValidationUtils.validateNum = function validateNum(arg) {
    var val = (0, _str.cropStr)((0, _str.clearNonDigits)(arg.valIn), arg.maxLength)
    var length = val.length
    var isEmpty = length === 0
    return {
      isEmpty: isEmpty,
      isValid: arg.checker({ clearedVal: val, length: length }),
      val: isEmpty ? -1 : (0, _num.castNum)(val, arg.oldVal)
    }
  }
  ValidationUtils.setValidatedNumParam = function setValidatedNumParam(valWrp, params) {
    valWrp.isEmpty = params.isEmpty
    valWrp.isValid = params.isValid
    valWrp.val = params.val
  }
  ValidationUtils.validateAndSetNum = function validateAndSetNum(valWrp, valIn, checker) {
    this.setValidatedNumParam(
      valWrp,
      ValidationUtils.validateNum({
        valIn: valIn,
        oldVal: valWrp.val,
        maxLength: valWrp.maxLength,
        checker: checker
      })
    )
  }
  return ValidationUtils
})()
exports.default = ValidationUtils



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/ValidationUtils/index.js
// module id = 634
// module chunks = 0